module.exports = "/images/airplane.svg?ae35bba33c2562c36c1afb9a733674b5";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/airplane.svg
// module id = IoKL
// module chunks = 0